import React, { useState, useRef } from "react";
// import swal from 'sweetalert';
// import emailjs from '@emailjs/browser';
// import Swal from 'sweetalert2';

const PricingModal = (props) => {
  const [showModal, setShowmodal] = useState(false);

  const MyModal = () => {
    return (
      <>
        <div
          className="modal fade show "
          id="exampleModal"
          tabIndex={-1}
          aria-labelledby="exampleModalLabel"
          aria-modal="true"
          role="dialog"
          style={{ display: "block", paddingLeft: "0px", height: "" }}
        >
          <div className="modal-dialog" style={{ maxWidth: "800px" }}>
            <div className="modal-content" style={{ height: "auto" }}>
              <div className="modal-header px-1 py-0">
                <div
                  className="mbr-section-head"
                  style={{ marginLeft: "12px" }}
                >
                  <h6
                    className="mbr-section-title mbr-fonts-style align-center mb-0 display-2"
                    style={{ fontSize: "30px", fontWeight: "bold" }}
                  >
                    {props.heading}
                  </h6>
                </div>

                <button
                  onClick={() => setShowmodal(false)}
                  type="button"
                  className="btn-close mr-1"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  fdprocessedid="wa6amw"
                  style={{ marginRight: "4px", marginTop: "0" }}
                />
              </div>

              <div className="modal-body">
                <div className="box">
                  <form id="form" className="row">
                    <div className="col-12 col-lg-6">
                      <input type="text" name="user_name" id="name" required />
                      <label>Full Name: </label>
                    </div>
                    <div className="col-12 col-lg-6">
                      <input
                        type="text"
                        name="designation"
                        id="name"
                        required
                      />
                      <label>Designation: </label>
                    </div>
                    <div className="col-12 col-lg-6">
                      <input type="number" name="number" required />
                      <label>Contact</label>
                    </div>
                    <div className="col-12 col-lg-6">
                      <input type="email" name="user_email" required />
                      <label>Email</label>
                    </div>

                    <div className="col-12 col-lg-12">
                      <input type="text" name="hospital" required />
                      <label>Hospital Name</label>
                    </div>

                    <div className="col-12 col-lg-12">
                      <input type="text" name="address" required />
                      <label>Address</label>
                    </div>

                    <div className="col-12 col-lg-12">
                      <textarea name="message" placeholder="" required />
                      <label>Message</label>
                    </div>

                    <input id="submit" type="submit" defaultValue="Submit" />
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };
  return (
    <>
      <button
        onClick={() => setShowmodal(true)}
        className="btn btn-primary"
        style={{
          width: "150px",
          padding: "5px",
        }}
      >
        {props.head}
      </button>
      {showModal && <MyModal />}
    </>
  );
};

export default PricingModal;
